import { createFileRoute } from '@tanstack/react-router';
import { FinancialAccountsPage } from '@/features/accounting/parameters/financial-accounts/components/FinancialAccountsPage';

export const Route = createFileRoute(
  '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <FinancialAccountsPage />;
}
